import { RegistrationRoute } from "apps/registration/routes/route";
import IFrameQueryParam from "shared/enums/IFrameQueryParam";
import NonAttendeeApplicationStatus from "shared/enums/NonAttendeeApplicationStatus";
import { RedirectQueryParam, Route } from "shared/enums/Redirect";
import TicketStatus from "shared/enums/TicketStatus";
import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import { Base64Util } from "shared/utils/base64";
import { isInIframe } from "shared/utils/iframe";

export function isRegistrationParticipantTicketAssignmentPending(ticketStatus: TicketStatus) {
  return [TicketStatus.TICKET_ACCEPTANCE_PENDING].includes(ticketStatus);
}

export function isRegistrationParticipantPaymentPending(ticketStatus: TicketStatus) {
  return [
    TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING,
    TicketStatus.PAYMENT_FLOW_PAYMENT_PENDING,
    TicketStatus.TICKET_TRANSFER_ACCEPTANCE_PENDING
  ].includes(ticketStatus);
}

export function isBulkTicketPaymentPending(nonAttendeeApplicationStatus: NonAttendeeApplicationStatus) {
  return nonAttendeeApplicationStatus === NonAttendeeApplicationStatus.BULK_TICKET_APPLICATION_PAYMENT_PENDING;
}

// returns redirect url for reg when stripe payment is successful
export function getStripeReturnUrl(
  participantObj: ApiRegistrationParticipantForParticipantResponse,
  searchParams: URLSearchParams
) {
  const ptUrl = new URL(window.location.href);
  ptUrl.pathname = RegistrationRoute.Redirect;
  ptUrl.searchParams.append(RedirectQueryParam.ROUTE, Route.STRIPE_STATUS);
  ptUrl.searchParams.append(
    RedirectQueryParam.PURCHASE_ORDER_ID,
    participantObj.regPurchaseOrder?.purchaseOrderId as string
  );
  ptUrl.searchParams.append(RedirectQueryParam.REG_PARTICIPAN_UI_VERSION, participantObj.uiVersion.toString());

  if (isInIframe) {
    // if we are displaying in iframe then we want to put the Personatech reg url as a query param
    //    integration team needs to base64decode this url and set in iframe along with other stripe params
    ptUrl.searchParams.append(
      IFrameQueryParam.IFRAME_PARENT_URL,
      searchParams.get(IFrameQueryParam.IFRAME_PARENT_URL) as string
    );
    const toReturnUrl = new URL(searchParams.get(IFrameQueryParam.IFRAME_PARENT_URL) as string);
    toReturnUrl.searchParams.append(
      IFrameQueryParam.PERSONATECH_REG_URL,
      Base64Util.encode(ptUrl.toString()) as string
    );
    return toReturnUrl.toString();
  }

  return ptUrl.toString();
}
